module.exports = __webpack_public_path__ + "static/media/hot_zgxsd.7eb28cc5.png";